import { contractApi } from '../contractApi';
import { FeeScheduleView } from '../types/contractTypes';
import { FeeScheduleGetRequest } from '../requests/feeScheduleGetRequest';
import { FeeSchedulesByContractIdRequest } from '../requests/feeSchedulesByContractIdRequest';
import { FeeScheduleUpsertRequest } from '../requests/feeScheduleUpsertRequest';

const feeScheduleEndpointsInjected = contractApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get fee schedule by ID
    getFeeSchedule: builder.query<FeeScheduleView, FeeScheduleGetRequest>({
      query: ({ id }) => ({
        url: 'FeeScheduleGetById',
        params: { id },
      }),
      providesTags: (result, error, { id }) => [{ type: 'FeeSchedule', id }, 'FeeSchedule'],
    }),

    // Get all fee schedules by contract ID
    getFeeSchedulesByContractId: builder.query<FeeScheduleView[], FeeSchedulesByContractIdRequest>({
      query: ({ contractId }) => ({
        url: 'FeeSchedules',
        method: 'GET',
        params: { contractId },
      }),
      providesTags: (result, error, { contractId }) => [
        { type: 'FeeScheduleList', id: contractId },
        'FeeSchedule',
      ],
    }),

    // Upsert fee schedule (create or update)
    upsertFeeSchedule: builder.mutation<FeeScheduleView, FeeScheduleUpsertRequest>({
      query: (body) => ({
        url: 'FeeSchedule',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, body) => [
        ...(body.feeSchedule.id
          ? [{ type: 'FeeSchedule' as const, id: body.feeSchedule.id }]
          : []),
        { type: 'FeeScheduleList', id: body.feeSchedule.contractId },
        'FeeSchedule',
        'FeeScheduleList',
      ],
    }),

    // Delete fee schedule (soft delete)
    deleteFeeSchedule: builder.mutation<void, { id: string; contractId: string }>({
      query: ({ id }) => ({
        url: 'FeeScheduleDelete',
        method: 'DELETE',
        params: { id },
      }),
      invalidatesTags: (result, error, { id, contractId }) => [
        { type: 'FeeSchedule', id },
        { type: 'FeeScheduleList', id: contractId },
        'FeeSchedule',
        'FeeScheduleList',
      ],
    }),
  }),
  overrideExisting: false,
});

// Export enhanced API for slice extraReducers
export const feeScheduleEndpoints = feeScheduleEndpointsInjected;

export const {
  useGetFeeScheduleQuery,
  useGetFeeSchedulesByContractIdQuery,
  useUpsertFeeScheduleMutation,
  useDeleteFeeScheduleMutation,
} = feeScheduleEndpointsInjected;
